import { makeHttpRequest } from "@/shared";

export const deleteSelling = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/stock/${id}`,
            method: "DELETE",
        })
    ).data;

    return response;
};
